export function parseNewLines(text: string) {
    if (text) {
        return text.replace(/##/g, '\n');
    }
    return '';
}

export const wrapKeyword = (input: string, keyword: string): string => {
    if (!keyword?.trim()) {
        return input;
    }

    const words = keyword.trim().split(/\s+/);
    const escaped = words.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const startsAlphanumeric = (w: string) => /^[A-Za-z0-9]/.test(w);
    const tokenPatterns = words.map((w, i) =>
        (startsAlphanumeric(w) ? `(?<=^|[^A-Za-z0-9])${escaped[i]}` : escaped[i]),
    );
    const pattern = new RegExp(`(${tokenPatterns.join('|')})`, 'gi');
    return input.replace(pattern, `{$1}`);
};

/**
 * Accessible name for an info-icon tooltip trigger: "{title}: {moreInfo}" (e.g.
 * "Required Salesforce Products: More information"), or whichever part is present.
 */
export function buildTooltipAriaLabel(title: string, moreInfo: string): string {
    return title && moreInfo ? `${title}: ${moreInfo}` : title || moreInfo;
}
